import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface EditIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function AddStopIcon({ color = RoutalPalette.secondary60, style = {}, ...props }: EditIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 23" style={{ width: `20px`, height: `20px`, ...style }}>
      <g>
        <g>
          <path
            d="M21.377 8.04893C20.9706 7.26905 20.3746 6.55207 19.6159 5.9483C18.8573 5.34453 17.9632 4.86654 16.9743 4.55207C16.1344 4.27534 15.2403 4.13698 14.3327 4.09924C14.3869 4.46402 14.414 4.8288 14.414 5.19358C14.414 6.01119 14.2785 6.80365 14.0482 7.55836C14.0482 9.25648 15.5384 10.6275 17.3943 10.6275C17.5026 10.7282 17.5026 10.8917 17.3943 10.9797C15.5519 10.9797 14.0482 12.3508 14.0482 14.0489C13.9398 14.1496 13.7637 14.1496 13.6689 14.0489C13.6689 12.7785 12.829 11.6841 11.6369 11.2187C10.228 12.4766 8.3721 13.3194 6.31299 13.508C8.03343 18.1873 13.0999 21.8099 13.3302 21.9986C13.4792 22.0992 13.6689 22.1621 13.8721 22.1621C14.0753 22.1621 14.265 22.0992 14.414 21.9986C14.7255 21.7848 22.0002 16.5647 22.0002 10.5143C22.0002 9.65899 21.7834 8.8288 21.377 8.03635V8.04893Z"
            fill={color}
          />
          <path
            d="M10.8374 5.19356C10.8374 4.84136 10.5394 4.56463 10.1601 4.56463H6.09606V0.79104C6.09606 0.438839 5.79803 0.162109 5.41872 0.162109C5.03941 0.162109 4.74138 0.438839 4.74138 0.79104V4.56463H0.67734C0.29803 4.56463 0 4.84136 0 5.19356C0 5.54576 0.29803 5.82249 0.67734 5.82249H4.74138V9.59607C4.74138 9.94827 5.03941 10.225 5.41872 10.225C5.79803 10.225 6.09606 9.94827 6.09606 9.59607V5.82249H10.1601C10.5394 5.82249 10.8374 5.54576 10.8374 5.19356Z"
            fill={color}
          />
        </g>
      </g>
    </SvgIcon>
  );
}
